export default __webpack_public_path__ + "static/media/flexible_learning.906b476b.png";